//@ts-ignore
//@ts-nocheck
import { Grid } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getUserData,
  registerPendingPayment,
  registerSponsoredPlayer,
  uploadFormDocuments,
} from "../../api/Payment";
import MarkLogoWhite from "../../assets/images/MarkLogo.png";
import CheckRender from "../../components/CheckRender/CheckRender";
import MaskTextField from "../../components/MaskTextField/MaskTextField";
import RadioButtonGroup from "../../components/RadioButtonGroup";
import TextField from "../../components/TextField/TextField";
import { RootState } from "../../stores/AppReducers";
import GlobalLoadingActions from "../../stores/GlobalLoading/Actions";
import { StyledButton } from "../../theme/Styles";
import useDebounce from "../../utilities/hooks/useDebounce";
import { FormSchema, TRegisterBody } from "./PaymentConstants";
import PaymentModal from "./components/PaymentModal";
import RequestStatusModal from "./components/RequestStatusModal";
import {
  Container,
  FormContainer,
  LeftContainer,
  LogoImg,
  RightContainer,
} from "./styles/PaymentStyles";
import { AxiosRequestConfig } from "axios";

function Payment(props: ScreenProps) {
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const userDocument = searchParams.get("document");

  const formik = useFormik({
    initialValues: {
      sponsoredPlayer: false,
      sponsor: "",
    //  verificationCode: "",
      name: "",
      lastname: "",
      email: "",
      documentType: 1,
      documentNumber: "",
    },
    validationSchema: FormSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, actions) => {
      setShowPaymentModal(true)
  /*     if (values.sponsoredPlayer) {
        handleSponsorValidation(values);
      } else {
        setShowPaymentModal(true);
      } */
    },
  });
  const [selectedFile, setSelectedFile] = useState();
  const [loadingPercent, setLoadingPercent] = useState(0);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showRequestStatusModal, setShowRequestStatusModal] = useState(false);
  const [statusModalMessage, setStatusModalMessage] = useState();
  const [canContinue, setCanContinue] = useState(false);

  const debouncedDocumentNumber = useDebounce(
    formik.values.documentNumber,
    700
  );

  const handleSponsorValidation = async (data: TRegisterBody) => {
    try {
      const response = await registerSponsoredPlayer({
        code: data.verificationCode,
        document: data.documentNumber,
      });
      if (response.ok) {
        setShowRequestStatusModal(true);
        setStatusModalMessage({
          variant: "success",
          content: "Registro Exitoso",
        });
      } else {
        setShowRequestStatusModal(true);
        setStatusModalMessage({
          variant: "error",
          content: "El código proporcionado no coincide con su patrocinador.",
        });
      }
    } catch (error) {}
  };

  const handleCardnetPayment = async () => {
    try {
      const request = {
        document: formik.values.documentNumber,
      };
      const response = await registerPendingPayment(request);
      if (response.ok) {
        let form = document.createElement("form");
        form.style.display = "none";
        form.action = response.payment.url;
        form.method = "POST";
        const input = document.createElement("input");
        input.name = "SESSION";
        input.value = response.payment.session;
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUploadVoucher = async () => {
    try {
      const uploadConfig: AxiosRequestConfig = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setLoadingPercent(percentCompleted);
        },
      };
      const form = new FormData();
      form.append("file", selectedFile, selectedFile.name);
      form.append("document", debouncedDocumentNumber);
      const response = await uploadFormDocuments(form, uploadConfig);
      if (response.ok) {
        setShowPaymentModal(false);
        formik.resetForm();
        setShowRequestStatusModal(true);
        setStatusModalMessage({
          variant: "success",
          content: "Su pago está en proceso de revisión.",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAndSetUserDataByDocument = async (documentNumber: string) => {
    try {
      const response = await getUserData(documentNumber);
      if (response.document === documentNumber) {
        formik.setFieldValue("name", response.firstname);
        formik.setFieldValue("lastname", response.lastname);
        formik.setFieldValue("email", response.email);
        if (response.sponsor !== null && response.sponsor !== undefined) {
          formik.setFieldValue("sponsoredPlayer", true);
          formik.setFieldValue("sponsor", response.sponsor);
        }

        /* VALIDATE request and paid status */
        if (response.status === 0) {
          /* in proccess */
          setShowRequestStatusModal(true);
          setStatusModalMessage({
            variant: "error",
            content:
              "Su solicitud de participación está en proceso de aprobación.",
          });
          return;
        }
        if (response.status === 4) {
          /* payment in proccess */
          setShowRequestStatusModal(true);
          setStatusModalMessage({
            variant: "error",
            content: "Su pago está en proceso de revisión.",
          });
          return;
        }
        if (response.paid === 1) {
          /* payment success */
          setShowRequestStatusModal(true);
          setStatusModalMessage({
            variant: "success",
            content: "Su pago ha sido procesado",
          });
          return;
        }
        setCanContinue(true);
      } else {
        throw new Error("error");
      }
    } catch (error) {
      formik.setFieldValue("name", "");
      formik.setFieldValue("lastname", "");
      formik.setFieldValue("email", "");
      formik.setFieldValue("sponsoredPlayer", false);
      formik.setFieldValue("sponsor", "");
      setCanContinue(false);
    }
  };

  /* componentDidUpdate */
  useEffect(() => {
    /* in cedula cases only executes when length is 11 */
    if (
      formik.values.documentType == "1" &&
      debouncedDocumentNumber.length === 11
    ) {
      getAndSetUserDataByDocument(debouncedDocumentNumber);
    }

    if (formik.values.documentType == "2") {
      getAndSetUserDataByDocument(debouncedDocumentNumber);
    }
  }, [debouncedDocumentNumber]);

  /* Componentdidmount */
  useEffect(() => {
    /* from params cases */
    if (userDocument !== null) {
      /* 1 cedula 2 passport */
      formik.setFieldValue(
        "documentType",
        userDocument.length === 11 ? "1" : "2"
      );
      formik.setFieldValue("documentNumber", userDocument);
    }
  }, []);

  return (
    <Container>
      <PaymentModal
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        loadingPercent={loadingPercent}
        onCardnetClick={handleCardnetPayment}
        onUploadVoucherClick={handleUploadVoucher}
        setShowDialogModal={setShowPaymentModal}
        showDialogModal={showPaymentModal}
      />
      <RequestStatusModal
        setShowDialogModal={() => {
          setShowRequestStatusModal();
          formik.resetForm();
        }}
        message={statusModalMessage}
        showDialogModal={showRequestStatusModal}
      />
      <LeftContainer>
        <LogoImg src={MarkLogoWhite} />
      </LeftContainer>
      <RightContainer>
        <FormContainer>
          <h1>Confirmación de participación</h1>
          <p>Introduce su número de documento para continuar.</p>
          <br />
          <Grid
            alignItems="center"
            container
            direction="row"
            justifyContent={"flex-start"}
            spacing={{ xs: 1, md: 1.5 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={6}>
              <RadioButtonGroup
                required
                row
                id="documentType"
                title="Tipo de documento"
                options={[
                  { label: "Cédula", value: 1 },
                  { label: "Pasaporte", value: 2 },
                ]}
                value={formik.values.documentType}
                onChange={formik.handleChange}
                error={
                  formik.touched.documentType &&
                  Boolean(formik.errors.documentType)
                }
                helperText={
                  formik.touched.documentType && formik.errors.documentType
                }
              />
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              <MaskTextField
                required
                id="documentNumber"
                type="text"
                maskType={
                  formik.values.documentType == "1" ? "cedula" : "passport"
                }
                title="Documento"
                placeholder="Documento"
                value={formik.values.documentNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.documentNumber &&
                  Boolean(formik.errors.documentNumber)
                }
                helperText={
                  formik.touched.documentNumber && formik.errors.documentNumber
                }
              />
            </Grid>

         {/*    <CheckRender allowed={formik.values.sponsoredPlayer}>
              <Grid item xs={12} sm={4} md={6}>
                <TextField
                  required
                  id="verificationCode"
                  type="text"
                  title="Código de Verificación"
                  placeholder="Código de Verificación"
                  value={formik.values.verificationCode}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.verificationCode &&
                    Boolean(formik.errors.verificationCode)
                  }
                  helperText={
                    formik.touched.verificationCode &&
                    formik.errors.verificationCode
                  }
                />
              </Grid>
            </CheckRender> */}

            <CheckRender allowed={formik.values.sponsoredPlayer}>
              <Grid item xs={12} sm={4} md={6}>
                <TextField
                  id="sponsor"
                  type="text"
                  title="Patrocinador"
                  placeholder="Patrocinador"
                  value={formik.values.sponsor}
                />
              </Grid>
            </CheckRender>

            <Grid item xs={4} sm={4} md={6}>
              <TextField
                id="name"
                type="text"
                title="Nombres"
                placeholder="Nombres"
                value={formik.values.name}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={6}>
              <TextField
                id="lastname"
                type="text"
                title="Apellidos"
                placeholder="Apellidos"
                value={formik.values.lastname}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={6}>
              <TextField
                id="email"
                type="email"
                title="Email"
                placeholder="Email"
                value={formik.values.email}
              />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="flex-end"
            direction="row"
            justifyContent={"end"}
            spacing={{ xs: 1, md: 1.5 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={4} sm={8} md={3}>
              <StyledButton
                disabled={!canContinue}
                onClick={() => formik.handleSubmit()}
                variant="contained"
              >
                Continuar
              </StyledButton>
            </Grid>
          </Grid>
          <br />
        </FormContainer>
      </RightContainer>
    </Container>
  );
}

interface ScreenProps extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.signin.user,
});

const mapDispatchToProps = {
  showGlobalLoading: GlobalLoadingActions.showGlobalLoading,
  hideGlobalLoading: GlobalLoadingActions.hideGlobalLoading,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Payment);
